<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { TextFilter } from '../Filters'

export default defineComponent({
  props: {
    filter: {
      type: Object as PropType<TextFilter>,
      required: true,
    },
  },
  setup(props) {
    return () => (
      <div class="ark-ui-filterbar-text-filter">
        {props.filter.label}
      </div>
    )
  },
})
</script>

<style lang="scss" scoped>
</style>
